var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.471 4.52722C13.5959 4.65224 13.6661 4.82178 13.6661 4.99856C13.6661 5.17533 13.5959 5.34487 13.471 5.46989L7.13762 11.8032C7.0126 11.9282 6.84306 11.9984 6.66629 11.9984C6.48951 11.9984 6.31997 11.9282 6.19495 11.8032L3.19495 8.80322C3.07352 8.67749 3.00632 8.50909 3.00784 8.33429C3.00936 8.15949 3.07947 7.99228 3.20307 7.86868C3.32668 7.74507 3.49389 7.67496 3.66869 7.67344C3.84348 7.67192 4.01189 7.73912 4.13762 7.86056L6.66629 10.3892L12.5283 4.52722C12.6533 4.40224 12.8228 4.33203 12.9996 4.33203C13.1764 4.33203 13.3459 4.40224 13.471 4.52722Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.ee4ae6f8b7ae694506fd473a6a0b23b3.svg";
export { ForwardRef as ReactComponent };